import React from 'react';
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useHtmlViewer } from './HtmlViewerContext';
import type { ViewerMode } from './HtmlViewerTypes';

export const HtmlViewerToolbar = () => {
  const { state, dispatch } = useHtmlViewer();

  const handleModeChange = (
    _event: React.MouseEvent<HTMLElement>,
    newMode: ViewerMode | null
  ) => {
    if (newMode !== null) {
      dispatch({ type: 'SET_MODE', payload: newMode });
    }
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        px: 1,
        py: 0.5,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <ToggleButtonGroup
        value={state.mode}
        exclusive
        onChange={handleModeChange}
        size="small"
        aria-label="viewer mode"
      >
        <ToggleButton value="read" aria-label="read mode">
          <Typography variant="caption" sx={{ mr: 0.5 }}>
            📖
          </Typography>
          <Typography variant="caption">읽기</Typography>
        </ToggleButton>
        <ToggleButton value="highlight" aria-label="highlight mode">
          <Typography variant="caption" sx={{ mr: 0.5 }}>
            🖊
          </Typography>
          <Typography variant="caption">하이라이트</Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};
